<template>
  <div class="table-group">
    <div v-for="(item, index) in list" :key="index" class="m-b-20">
      <div class="group-title">
        <span>工艺分类(</span>
        <span class="c-orange">{{
          item.name_list.length ? item.name_list[item.name_list.length - 1] : '其他分类'
        }}</span>
        <span>)</span>
      </div>
      <vxe-grid
        :size="tableConfig.size"
        :border="tableConfig.border"
        :min-height="tableConfig.minHeight"
        :footer-method="tableFooterMethod"
        :columns="tableColumn"
        :data="item.list"
        :show-footer="!!item.list.length"
      >
        <!-- slot_default -->
        <template #default_list_chan_pin_tu="{ row }">
          <e-upload-image v-if="row.list_chan_pin_tu" :list.sync="row.list_chan_pin_tu" disabled />
        </template>
        <template #default_list_gong_cheng_tu="{ row }">
          <e-upload-image :list.sync="row.list_gong_cheng_tu" disabled />
        </template>
        <template #default_list_yuan_wen_jian="{ row }">
          <e-upload-file :list.sync="row.list_yuan_wen_jian" disabled />
        </template>
        <template #default_list_jian_ce_mu_ban="{ row }">
          <e-upload-file :list.sync="row.list_jian_ce_mu_ban" disabled />
        </template>
        <template #default_list_jian_ce_bao_gao="{ row }">
          <e-upload-file :list.sync="row.list_jian_ce_bao_gao" disabled />
        </template>
        <template #default_jin_du="{ row }">
          <div class="flex">
            <div class="flex flex-y-center" v-for="(item, index) in jin_du_list" :key="index">
              <span v-if="index">-</span>
              <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
              <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
              <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
            </div>
          </div>
        </template>
        <template #default_operate="{ row }">
          <el-link type="primary" @click.native="itemRenwu(row.bill_id, row.id)">生产工单</el-link>
          <el-link type="primary" @click.native="itemWeiwai(row.bill_id, row.id)">委外工单</el-link>
        </template>
      </vxe-grid>
    </div>

    <!-- 弹窗-生产工单增改 -->
    <PopupRenwu
      v-if="isShowPopupRenwu"
      :show.sync="isShowPopupRenwu"
      :billId="activeBillId"
      :jiagongId="activeJiagongId"
      @success="updatePage"
    />

    <!-- 弹窗-委外工单增改 -->
    <PopupWeiwai
      v-if="isShowPopupWeiwai"
      :show.sync="isShowPopupWeiwai"
      :billId="activeBillId"
      :jiagongId="activeJiagongId"
      @success="updatePage"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupWeiwai: () => import('@/views/new/weiwai/common/popup-do/index'),
    PopupRenwu: () => import('@/views/new/renwu/common/popup-do/index')
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isShowPopupRenwu: false,
      isShowPopupWeiwai: false,
      jin_du_list: ['待加工', '加工中', '已完成'],
      tableColumn: [
        {
          title: '工艺顺序',
          field: 'seq',
          width: 63
        },
        {
          title: '工艺图片',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '工艺名称',
          field: 'name',
          width: 144
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 100
        },
        {
          title: '单位',
          field: 'unit',
          width: 70
        },
        {
          title: '数量',
          field: 'counts',
          width: 70
        },
        {
          title: '单价',
          field: 'goods_price',
          width: 80
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' },
          width: 80
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' },
          width: 80
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' },
          width: 80
        },
        {
          title: '进度',
          field: 'jin_du',
          slots: { default: 'default_jin_du' },
          width: 132
        },
        {
          title: '备注',
          field: 'remark'
        },
        {
          title: '操作',
          width: 120,
          slots: { default: 'default_operate' }
        }
      ]
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig)
      return result
    }
  },
  methods: {
    // 表格底部
    tableFooterMethod({ columns, data }) {
      // 重新计算行金额，修复金额合计不是最新结果的问题
      data.forEach((item) => {
        let a = Number(item.goods_price)
        let b = Number(item.counts)
        item.goods_amount = this.$XEUtils.multiply(a, b)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'goods_price', 'goods_amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    },
    // 更新页面
    updatePage() {},
    // 项-生产工单
    itemRenwu(billId, jiagongId) {
      this.activeBillId = billId
      this.activeJiagongId = jiagongId
      this.isShowPopupRenwu = true
    },
    itemRenwuBatch(billId, item) {
      let gongxuIds = []
      for (let i = 0; i < item.list.length; i++) {
        if (item.list[i].id) {
          billId = item.list[i].bill_id
          gongxuIds.push(item.list[i].id)
        }
      }
      if (gongxuIds.length > 0) {
        //弹窗填写公共信息

        this.$api({
          method: 'post',
          url: '/admin/gcvip/shengChanGongDan/saveInitBatch',
          data: { billId: billId, gongxuIds: gongxuIds }
        })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      } else {
        this.$message.warning('没有待执行的工序')
      }
    },
    // 项-委外工单
    itemWeiwai(billId, jiagongId) {
      this.activeBillId = billId
      this.activeJiagongId = jiagongId
      this.isShowPopupWeiwai = true
    }
  }
}
</script>

<style lang="less" scoped>
.table-group {
  margin-bottom: 15px;
}
</style>
